import { render, staticRenderFns } from "./swiper-hot-live-home.vue?vue&type=template&id=413c402e&scoped=true"
import script from "./swiper-hot-live-home.vue?vue&type=script&lang=js"
export * from "./swiper-hot-live-home.vue?vue&type=script&lang=js"
import style0 from "./swiper-hot-live-home.vue?vue&type=style&index=0&id=413c402e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c402e",
  null
  
)

export default component.exports